import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updatePO: null,
  loading: false,
  error: null,
};

const updatePOSlice = createSlice({
  name: "updatePO",
  initialState,
  reducers: {
    fetchUpdatePOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchUpdatePOSuccess: (state, action) => {
      state.loading = false;
      state.updatePO = action.payload;
      state.error = null;
    },

    fetchUpdatePOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdatePOStart,
  fetchUpdatePOSuccess,
  fetchUpdatePOFailure,
} = updatePOSlice.actions;

export default updatePOSlice.reducer;